function SearchIcon() {

    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
            <path id="icon_search" d="M11.906,10.528a6.353,6.353,0,0,0,1.313-3.913A6.581,6.581,0,0,0,6.656,0,6.661,6.661,0,0,0,0,6.615,6.661,6.661,0,0,0,6.656,13.23a6.25,6.25,0,0,0,3.937-1.3l2.813,2.8a.91.91,0,0,0,1.312,0,.9.9,0,0,0,0-1.3Zm-5.25.745A4.708,4.708,0,0,1,1.875,6.615a4.781,4.781,0,0,1,9.562,0A4.708,4.708,0,0,1,6.656,11.273Z" transform="translate(0)" fill="#818e94"/>
        </svg>
    )
}

export default SearchIcon;